import { AllowedPageSection, HeroSectionType } from '../../lib/types'
import { FacadeService } from '../../lib/services/facade'

export const mergeSections = (
  heroSection: HeroSectionType | undefined,
  otherSections: AllowedPageSection[] | undefined
): AllowedPageSection[] => {
  return [heroSection, ...(otherSections || [])].filter((s): s is AllowedPageSection => Boolean(s))
}

/**
 * Formatting page slug to remove the leading slash.
 * Page Slug comes from Facade and includes the leading slash to follow the proposal. However,
 * there are dashboards that rely on the current format of pageSlug (without the leading slash).
 *
 * Keeping this until the dashboards are updated.
 */
export const formatPageSlug = (pageSlug: string): string => {
  if (pageSlug === '/') {
    return pageSlug
  }
  return pageSlug.replace(/^\//g, '')
}

/**
 * Gets the page slug from facade and formats it, defaulting to 'unknown' if not available.
 */
export const getPageSlugFromFacade = (facade: FacadeService): string => {
  return formatPageSlug(facade.get().pageSlug ?? 'unknown')
}
